const eLearningList = document.querySelector('.e-learning');

if (eLearningList) {
  const urlParams = ['filteredELearningCategory', 'pageNumber'];

  const getExtraFormDataInput = (parent) => ({
    filteredELearningCategory: getActiveCategoryButtonFilter(parent),
    initialCategories: parent.querySelector('[data-initial-categories]').value,
  });

  // Category filter click
  attachEvent('.e-learning .mod-filter__link', 'click', (ev) => {
    const parent = ev.target.closest('.e-learning');
    parent.querySelectorAll('.mod-filter__link').forEach((el) => el.classList.remove('is-active'));

    const tab = ev.target.closest('.mod-filter__link');
    tab.classList.add('is-active');

    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Pagination
  attachEvent('.e-learning .e-learning__pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.e-learning');
    axiosGetPaginateAndFilteredPosts(parent, ev.target.dataset.page || 1, urlParams, getExtraFormDataInput(parent));
  });
}
